





















































import Vue from "vue";
import { Prop, Provide, Watch } from "vue-property-decorator";
import "@mdi/font/css/materialdesignicons.css";
import Component from "vue-class-component";
import CartViewModel from "@/chipply/view-model/CartViewModel";
import { DealerLogoDisplay, StorePriceDisplayType } from "chipply-common";
import IEventCategoryDto from "@/chipply/i-event-category-dto";
import StoreFooter from "./layout/StoreFooter.vue";
import StoreAppBar from "./layout/StoreAppBar.vue";
import CategoryDesktopPanel from "./layout/CategoryDesktopPanel.vue";
import CategoryNavigation from "./layout/CategoryNavigation.vue";
import { StoreHelper } from "@/chipply/helper/StoreHelper";
import IPriceDisplay from "@/chipply/interface/IPriceDisplay";

@Component({
    components: { StoreFooter, StoreAppBar, CategoryDesktopPanel, CategoryNavigation },
})
export default class EcomLayout extends Vue {
    public name = "EcomLayout";

    @Prop({
        type: Boolean,
    })
    public skipLoad!: boolean;

    @Prop({
        type: Number,
    })
    public eventId!: number | null;

    @Prop({
        type: Boolean,
    })
    public checkout!: boolean | null;

    @Prop({
        type: Object,
    })
    public value!: CartViewModel;

    @Prop({
        default: false,
        type: Boolean,
    })
    public landing!: boolean;

    @Prop({
        type: Boolean,
        default: false,
    })
    public isPreview!: boolean;

    @Provide()
    public get priceDisplay(): IPriceDisplay {
        return this.sourcePriceDisplay;
    }

    private sourcePriceDisplay: IPriceDisplay = {
        displayType: StorePriceDisplayType.Dollars,
        dollarValuePerPoint: 0,
    };

    public cartQuantity = 0;
    private showCatNav = false;
    public DealerLogoDisplay = DealerLogoDisplay;
    private selectedCategory: IEventCategoryDto | null = null;
    public drawer = false;
    public isNavigationButtonVisible = false;
    private storeHelper = new StoreHelper();

    // @ts-ignore
    public $refs!: {
        navRef: HTMLElement;
    };

    public async created() {
        this.viewModelInitialized();

        if (this.eventId != null && !this.skipLoad) {
            await this.value.getBranding(this.eventId);
            await this.value.getCategories(this.eventId, true);
            this.updatePriceDisplay();
        }
    }

    @Watch("value.initialized")
    public viewModelInitialized() {
        this.cartQuantity = this.value.itemCount;
        this.viewModelBrandingChanged();
    }

    @Watch("value.branding")
    public viewModelBrandingChanged() {
        this.updatePriceDisplay();
    }

    private updatePriceDisplay() {
        // Modify properties of the existing object instead of replacing the entire object
        this.sourcePriceDisplay.displayType =
            this.value.branding.storePriceDisplayType || StorePriceDisplayType.Dollars;
        this.sourcePriceDisplay.dollarValuePerPoint = this.value.branding.storeDollarValuePerPoint || 0;
    }

    private toggleCatNav() {
        if (this.showCatNav == true) {
            this.showCatNav = false;
        } else {
            this.showCatNav = true;
        }
    }

    private get categories() {
        return this.value.categories ?? {};
    }

    private get logoLessNav() {
        if (this.value.branding.dealerLogoDisplay === DealerLogoDisplay.UseLogo) {
            return "185px";
        } else if (this.value.branding.dealerLogoDisplay === DealerLogoDisplay.NoLogoUseText) {
            return "175px";
        } else {
            return "100px";
        }
    }

    private blurNav() {
        this.toggleCatNav();
    }

    public viewAll() {
        location.assign("./store.aspx?eid=" + this.eventId + "&action=viewall");
    }

    private async selectCat(category: IEventCategoryDto) {
        this.selectedCategory = category;
        if (
            (category.containers && category.containers.length == 0) ||
            category.isPackage ||
            this.storeHelper.checkPasswords(category).length == 0 ||
            (category.hasPassword && !category.isAuthorized)
        ) {
            location.assign("./store.aspx?eid=" + this.eventId + "&acid=" + category.eventCategoryID);
        }
    }
}
